<template>
  <div class="page-view-report">
    <div class="panel-info-section">
      <div class="panel-info-section-title flex items-center">
        <a-icon type="caret-right" class="text-primary v-mr-xs" />
        <span class="text-bold">项目总结报告</span>
      </div>
      <a-table key="table-edit" class="list-table" size="small" rowKey="reportId" :pagination="false" :data-source="[]" :scroll="{ x: '100%' }"></a-table>
    </div>
    <div class="panel-info-section">
      <div class="panel-info-section-title flex items-center">
        <a-icon type="caret-right" class="text-primary v-mr-xs" />
        <span class="text-bold">子项目进展报告</span>
        <a-space class="v-ml-auto">
          <a-select size="small" :dropdown-match-select-width="false" v-model="filterForm.projectId" allow-clear style="width: 250px" placeholder="选择子项目" @change="handleFilter">
            <a-select-option :key="item.id" v-for="item in subProjs">{{ item.name }}</a-select-option>
          </a-select>
          <a-select size="small" :dropdown-match-select-width="false" v-model="filterForm.type" allow-clear style="width: 130px" placeholder="选择报告类型" @change="handleFilter">
            <a-select-option :value="1">月报</a-select-option>
            <a-select-option :value="2">季报</a-select-option>
            <a-select-option :value="3">年报</a-select-option>
            <a-select-option :value="4">重大活动报告</a-select-option>
            <a-select-option :value="9">其他</a-select-option>
          </a-select>
          <a-select size="small" v-model="filterForm.state" allow-clear style="width: 95px" placeholder="报告状态" v-if="tab == 1" @change="handleFilter">
            <a-select-option :value="0">待提交</a-select-option>
            <a-select-option :value="1">待审核</a-select-option>
            <a-select-option :value="9">审核通过</a-select-option>
          </a-select>
          <a-button-group size="small">
            <a-button @click="tab = 1" :type="tab == 1 ? 'primary' : 'default'">全部项目报告</a-button>
            <a-button @click="tab = 2" :type="tab == 2 ? 'primary' : 'default'">精选照片</a-button>
          </a-button-group>
        </a-space>
      </div>
      <a-table key="table-edit" class="list-table" size="small" rowKey="reportId" :loading="recordsLoading" :pagination="false" :data-source="records" :scroll="{ x: '100%' }">
        <a-table-column title="#" data-index="index" :width="50" align="center">
          <template slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="子项目名称" data-index="project.name" :ellipsis="true" align="left">
          <template slot-scope="text, record">
            <router-link class="text-indigo hover-line" :title="text" :to="{ path: '/project/own/talent/view', query: { id: record.projectId } }">{{ text }}</router-link>
          </template>
        </a-table-column>
        <a-table-column title="报告类型" :width="150" data-index="type" align="left">
          <template slot-scope="text, record">
            <a-tag color="#3f51b5" v-if="record.type == 1">月报</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 2">季报</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 3">年报</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 4">重大活动报告</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 9">其他</a-tag>
          </template>
        </a-table-column>
        <!-- <a-table-column title="报告名称" :ellipsis="true" data-index="reportName" align="left">
          <template slot-scope="text, record">
            {{ record.reportName }}
          </template>
        </a-table-column> -->
        <a-table-column title="报告文件" data-index="files" align="left">
          <template slot-scope="text, record">
            <file-container :img-size="[100, 55]" :files="record.files" :belongId="record.projectId" fileSign="P01" v-if="record.files && record.projectId"></file-container>
          </template>
        </a-table-column>
        <a-table-column title="提交时间" :width="130" data-index="createTime" align="left">
          <template slot-scope="text, record">
            <template v-if="record.state === 0">{{ record.createTime ? record.createTime.substring(0, 16) : '' }}</template>
            <template v-else>{{ record.submitTime ? record.submitTime.substring(0, 16) : '' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="报告提交人" data-index="creatorName" :width="160" :ellipsis="true" align="left" />
        <a-table-column title="状态" data-index="quantity" :width="100" align="left">
          <template slot-scope="text, record">
            <span class="text-red" v-if="record.state == 0">待提交</span>
            <template v-else-if="record.state == 9">审核通过</template>
            <span class="text-red" v-else>待审核</span><span class="text-red" v-if="record.checkResult == -1">(驳回)</span>
          </template>
        </a-table-column>
        <a-table-column title="操作" data-index="amount" :width="80" align="center">
          <template slot-scope="text, record">
            <a-space :size="10">
              <span class="font-xs hover-line text-indigo" title="处理" @click="$router.push(`/project/own/talent/report/review?id=${record.projectId}&rid=${record.reportId}`)" v-if="isProcessable(record.state)">处理</span>
              <template v-else-if="record.state === 0 && record.origin == 1">
                <span class="font-xs hover-line text-indigo" title="修改" @click="$router.push(`/project/own/talent/report/draft?id=${record.projectId}&rid=${record.reportId}`)">修改</span>
                <span class="font-xs hover-line text-red" title="删除" @click="handleDel(record)">删除</span>
              </template>
              <span class="font-xs hover-line text-indigo" title="查看" @click="$router.push(`/project/own/talent/report/detail?id=${record.projectId}&rid=${record.reportId}`)" v-else>查看</span>
            </a-space>
          </template>
        </a-table-column>
      </a-table>
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listSimpleProjs, listReport, delReport } from '@/api/project/common'
export default {
  name: 'ProjectReportList',
  data() {
    return {
      projectId: null,
      records: [],
      recordsLoading: false,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      filterForm: {
        projectId: undefined,
        type: undefined,
        state: undefined,
      },
      subProjs: [],
      tab: 1,
      showRecord: false,
      recordId: undefined,
    }
  },
  computed: {
    project: vm => vm.$store.state.app.project,
  },
  watch: {
    tab() {
      this.loadRecords()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.loadRecords()
        this.loadSubProjs()
      }
    },
    handleFilter() {
      this.loadRecords()
    },
    loadRecords(page = 1, pageSize = 10, sorter) {
      this.recordsLoading = true
      let params = {
        pid: this.projectId,
        page,
        pageSize,
        sorter,
        origin: 1,
      }
      let { type, projectId, state} = this.filterForm
      if (type) {
        params.type = type
      }
      if (projectId) {
        params.projectId = projectId
        params.pid = null
      }
      if (state !== void 0) {
        if (state == 1) {
          params.states = [1, 2, 3]
        } else {
          params.state = state
        }
      }
      let { tab } = this
      if (tab == 2) {
        params.state = 9
        params.isChosen = 1
      }
      listReport(params).then(({ data }) => {
        if (data.success) {
          let { current, size, total, records } = data.result
          records.forEach(item => {
            if (item.medias) {
              item.files = (tab == 2 ? item.medias.filter(m => m.isChoice && m.file && ['jpg', 'jpeg', 'png', 'gif'].includes(m.file.fileFormat)) : item.medias).map(m => ({ ...m.file, isChoice: m.isChoice }))
            }
          })
          this.records = records
          this.pagination = {
            page: current,
            pageSize: size,
            total,
          }
        }
        this.recordsLoading = false
      })
    },
    loadSubProjs() {
      let params = {
        type: 23,
        isMain: 0,
        pid: this.projectId,
      }
      listSimpleProjs(params)
        .then(({ data }) => {
          if (data.success) {
            this.subProjs = data.result
          }
        })
    },
    onPageChange(page, pageSize) {
      this.loadRecords(page, pageSize)
    },
    handleDel(record) {
      this.$confirm({
        title: '确认删除？',
        centered: true,
        onOk: () => {
          // 异步关闭
          return new Promise((resolve, reject) => {
            let { reportId, projectId } = record
            delReport(reportId, projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.loadRecords()
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => {});
        },
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
